<template>
	<div class="header-nav layout-column layout-hv-center bg-white" @scroll.passive="handleScroll">
		<div class="block"></div>
		<div class="header bg-white layout-row layout-hv-center">
			<div class="header-content">
				<div class="top layout-row" :class="{'hide-login': hideLogin}">
					<el-dropdown class="login-menu layout-row layout-hv-center pointer" v-if="userInfo.id" @command="handleCommand">
						<div class="layout-row layout-hv-center">
							<!-- 大頭貼 後續補上 -->
							<!-- <img width="15px" height="15px" src="http://inlolcats.com/lolz/photos-public-domain-com/cuddling-cats-600x400.jpg" alt=""> -->
							<span class="el-dropdown-link text">
								你好，{{userInfo.name}}
								<i class="el-icon-caret-bottom el-icon--right"></i>
							</span>
						</div>
						<el-dropdown-menu slot="dropdown">
							<!-- 官網還未完成先沒有首頁 -->
							<el-dropdown-item v-for="(route, i) in routes" :key="i" :command="{type: 'linkTo', route}">{{route.text}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<div class="login-regist bg-yellow2 color-text2 pointer layout-row layout-hv-center" @click="$router.push({name: 'Login', query: { manager: false }})" v-if="!userInfo.id">
						<div class="text">登入/註冊</div>
					</div>
					<div class="login-regist bg-line3 color-text2 pointer layout-row layout-hv-center" @click="logout" v-else>
						<div class="text">登出</div>
					</div>
				</div>
				<div class="nav layout-row layout-align-center">
					<img src="../../assets/logo.svg" class="logo" alt="">
					<div class="button-box layout-row">
						<!-- 先拿掉 -->
						<!-- <div class="dfc button layout-row color-blue1 layout-hv-center pointer">什麼是DFC</div> -->
						<div class="stories button layout-row color-yellow1 layout-hv-center pointer" @click="linkUrl('https://www.dfctaiwan.org/stories')">
							解決問題的故事</div>
					</div>
					<div class="routes layout-row layout-align-center">
						<!-- 官網還未完成先沒有首頁 -->
						<!-- <div class="route-link color-text2 pointer" :class="isActive(route.name)" v-for="route in routes" :key="route.name" @click="linkTo(route.name)">{{route.text}}</div> -->
						<div class="route-link color-text2 pointer" v-for="(url, i) in urls" @click="linkUrl(url.url)" :key="i">{{url.text}}</div>
					</div>
					<div class="button-box layout-row">
						<div class="donet button layout-row color-green1 layout-hv-center pointer" @click="linkUrl('https://neti.cc/9pWzGlJ')">捐款支持</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
	data() {
		return {
			hideLogin: false,
			routes: [
				{
					// 內部 router 連結
					text: "我的 DFC",
					name: "myDFC"
				},
				{
					text: "個人資料",
					name: "personInfo"
				},
				{
					text: "報名DFC挑戰",
					name: "signUp",
					query: { page: "1" }
				},
				{
					text: "教學資源",
					name: "freeResource"
				}
			],
			urls: [
				{
					// 外部連結
					text: "如何報名DFC挑戰",
					url: "https://tycaa.dfctaiwan.org/dfc-challenge"
				},
				{
					text: "聯絡我們",
					url: "https://tycaa.dfctaiwan.org/join-us#section5"
				},
				{
					text: "關於DFC Taiwan",
					url: "https://tycaa.dfctaiwan.org/about"
				}
			]
		};
	},
	computed: {
		...mapState("user", ["userInfo"])
	},
	methods: {
		...mapActions(["logout"]),
		isActive(routeName) {
			return {
				"is-active": this.$route.name == routeName
			};
		},
		linkTo(route) {
			this.$router.push({ name: route.name, query: route.query });
		},
		linkUrl(url) {
			// 對外
			let win = window.open(url, "_blank");
			win.focus();
		},
		handleCommand(command) {
			if (command.type == "linkUrl") {
				this.linkUrl(command.url);
			} else if (command.type == "linkTo") {
				this.linkTo(command.route);
			}
		},
		handleScroll() {
			let scrollY = window.scrollY;
			if (scrollY > 100) {
				this.hideLogin = true;
			} else {
				this.hideLogin = false;
			}
		}
	},
	created() {
		window.addEventListener("scroll", this.handleScroll);
	},
	destroyed() {
		window.removeEventListener("scroll", this.handleScroll);
	},
	mounted() { },
	components: {}
};
</script>

<style lang='scss' scoped>
.header-nav {
	padding: 0 8px 18px 18px;
	font-size: 14px;
	position: relative;
	width: 100%;

	.block {
		width: 100%;
		height: 93px;
		margin-bottom: 56px;
	}

	.header {
		width: 100%;
		position: fixed;
		z-index: 100;
		top: 0;
		left: 0;
	}

	.header-content {
		width: 100%;
		max-width: 1280px;
	}

	.logo {
		width: 66px;
		height: 37px;
		margin-right: 33px;
	}

	.button-box {
		.button {
			width: 120px;
			padding: 5px 0;
			border-radius: 5px;
		}

		.button:hover {
			box-shadow: 4px 4px 12px 0 rgba(202, 207, 212, 0.5);
		}

		.button:first-child {
			margin-right: 10px;
		}

		.icon {
			margin-right: 4px;
		}

		.dfc {
			border: solid 1px #60adf5;
		}

		.dfc:hover {
			color: white;
			background-color: #60adf5;
		}

		.stories {
			border: solid 1px #f9c80e;
		}

		.stories:hover {
			color: white;
			background-color: #f9c80e;
		}

		.donet {
			border: solid 1px #a5ce38;
		}

		.donet:hover {
			color: white;
			background-color: #a5ce38;
		}
	}

	.routes {
		word-break: keep-all;
		font-size: 14px;
		margin-left: auto;
		margin-right: 5px;
		padding-left: 20px;

		.is-active {
			color: #ee6a8d;
		}

		.route-link {
			font-weight: 500;
			margin-right: 30px;
			max-width: 130px;
			text-align: center;
		}
	}

	.top {
		height: 30px;
		margin-bottom: 5px;
		transition: height cubic-bezier(0.075, 0.82, 0.165, 1.3) 0.5s;
		justify-content: flex-end;
	}

	.login-regist {
		width: 120px;
	}

	.login-menu {
		display: flex !important;
		margin-right: 10px;

		img {
			margin-right: 10px;
			border-radius: 100px;
		}
	}

	.nav {
		padding: 10px 15px;
	}

	.hide-login {
		height: 0;
		margin: 0;

		.text {
			display: none;
		}

		img {
			display: none;
		}
	}
}
</style>